export const getProfileQuery = `
  query GetProfile($input: GetProfileInput!) {
    getProfile(input: $input) {
        user {
            id
            firstName
            lastName
            email
            phone
            profileImage
            role
            companyId
            storeId
        }
        code
    }
  }
`;

// not all fields can be updated only firstName, lastName, phone and ProfileImage
//backend expects code and user
export const updateProfileQuery = `
  mutation UpdateProfile($input: UpdateProfileInput!) {
    updateProfile(input: $input) {
      code
      user {
        firstName
        lastName
        phone
        profileImage
      }
    }
  }
`;

//backend expects code

export const changePasswordQuery = `
  mutation ChangePassword($input: ChangePasswordInput!) {
    changePassword(input: $input) {
      code
    }
  }
`;

export const uploadProfileImageQuery = `
  mutation UploadProfileImage($file: Upload!) {
    uploadProfileImage(file: $file) {
      code
      user {
            id
            firstName
            lastName
            email
            phone
            profileImage
            role
            companyId
            storeId
        }
    }
  }
`;
